import React, { useEffect, useState } from "react";
import PageLayoutWithSidebar from "../../../../../components/PageLayoutWithSidebar";
import RealtySellingWrapper from "../style";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { t } from "i18next";
import { classNames } from "primereact/utils";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import { RadioButton } from "primereact/radiobutton";
import config, { configFun } from "../../../../../config";
import {
  getFormErrorMessage,
  getPersonStatus,
  isLand,
} from "../../../../../helpers/utils";
import moment from "moment";
import { getLandInsurance } from "../../../../../services";
import { Modal } from "antd";
import InputsComponent from "../../../../../components/Common/Form/InputComp";
import InputsRow from "../../../../../components/Common/Form/InputsRow";
import { Button } from "primereact/button";

const MortgageInfo = (props) => {
  const { demo, mortgage, foreclosureSale, sellingWithMortgage } = props;

  const sellingFormDetails = useSelector((state) => state.sellingFormDetails);
  const { selectedShares, buyersDetails } = sellingFormDetails;

  const [mortgageInfo, setMortgageInfo] = useState(
    sellingFormDetails.mortgageInfo || {
      isTransferableMortgage: true,
      isRented: true,
    }
  );

  const [internalReserve, setInternalReserve] = useState([]);
  const [externalReserve, setExternalReserve] = useState([]);
  const [internalModal, setInternalModal] = useState(false);
  const [externalModal, setExternalModal] = useState(false);

  const reserveColumns = [
    {
      label: t("realtySelling.documentNo"),
      key: "reservBookNo",
    },
    {
      label: t("realtySelling.reservBookDate"),
      key: "reservBookDate",
      body: (row) => <p>{moment(row.reservBookDate).format("DD/MM/YYYY")}</p>,
    },
    {
      label: t("realtySelling.reservetype"),
      key: "reserveType",
    },
    {
      label: t("realtySelling.partyAttNotes"),
      key: "partyAttNotes",
    },
  ];
  const reserveColumnsExternal = [
    {
      label: t("realtySelling.documentNo"),
      key: "rebookNo",
    },
    {
      label: t("realtySelling.reservBookDate"),
      key: "reservBookDate",
      body: (row) => <p>{moment(row.rebookDate).format("DD/MM/YYYY")}</p>,
    },
    {
      label: t("realtySelling.reservetype"),
      key: "reserveType",
    },
    {
      label: t("realtySelling.partyAttNotes"),
      key: "reservDesc",
    },
  ];
  // const [prevInsuranceData, setPrevInsuranceData] = useState([]);

  const handleInternal = (values) => {
    values.internalReserve.forEach((value) => {
      value["reserveType"] = t("realtySelling.internalActions");
    });
    setInternalReserve(values.internalReserve);
    setInternalModal(true);
  };

  const handleExternal = (values) => {
    values.externalReserve.forEach((value) => {
      value["reserveType"] = t("realtySelling.externalActions");
    });
    setExternalReserve(values.externalReserve);
    setExternalModal(true);
  };

  const updateState = (data) => {
    props.onUpdateFormData({ mortgageInfo: data });
  };

  const formik = useFormik({
    initialValues: {
      mortgageClass:
        mortgageInfo?.mortgageClass || configFun().mortgageClasses[0],
      mortgageAmount: mortgageInfo?.mortgageAmount || "",
      mortgagePeriod: mortgageInfo?.mortgagePeriod || "",
      dueDate: mortgageInfo?.dueDate || "",
      interest: mortgageInfo?.interest || "",
      interestValue: mortgageInfo?.interestValue || "",
      commission: mortgageInfo?.commission || "",
      mortgageTerms: mortgageInfo?.mortgageTerms || "",
      mortgageDurationInYears:
        parseInt(mortgageInfo.mortgageDuration / 12) || "",
      mortgageDurationInMonths: mortgageInfo.mortgageDuration % 12 || "",
      mortgageDuration: mortgageInfo.mortgageDuration || 0,
      isTransferableMortgage: mortgageInfo.isTransferableMortgage,
      isRented: mortgageInfo.isRented,
      isThereAmendmentToDebtor: mortgageInfo.isThereAmendmentToDebtor,
      prevInsuranceData: mortgageInfo.prevInsuranceData || [],
      tenants: mortgageInfo.tenants || [""],
    },
    validateOnMount: true,
    validate: (data) => {
      let errors = {};
      if (!data.mortgageAmount) {
        errors["mortgageAmount"] = t("errors.required");
      }
      // if (data.mortgageAmount <= 0 || isNaN(+data.mortgageAmount)) {
      if (data.mortgageAmount < 0 || isNaN(+data.mortgageAmount)) {
        errors["mortgageAmount"] = t("errors.biggerThanZero");
      }

      if (!data.mortgageClass) {
        errors["mortgageClass"] = t("errors.required");
      }
      if (mortgage || sellingWithMortgage) {
        if (!data.mortgagePeriod) {
          errors["mortgagePeriod"] = t("errors.required");
        }
        if (!data.interest) {
          errors["interest"] = t("errors.required");
        }
        if (!data.commission) {
          errors["commission"] = t("errors.required");
        }

        if (
          data.commission &&
          isNaN(+data.commission)
          // (data.commission <= 0 || isNaN(+data.commission))
        ) {
          errors["commission"] = t("errors.biggerThanZero");
        }

        if (data.interest === "withInterest") {
          if (data.interestValue < 0 || isNaN(+data.interestValue)) {
            errors["interestValue"] = t("errors.numOnly");
          }
        }
        if (data.mortgagePeriod === "period") {
          // if (data.mortgageDuration <= 0) {
          //   errors.mortgageDuration = t("errors.required");
          // }
          if (!data.dueDate) {
            errors["dueDate"] = t("errors.required");
          }
        }
      }
      return errors;
    },
    onSubmit: (data) => {
      updateState(data);
    },
  });

  const isFlat = (flag) => {
    return flag === "FLAT";
  };

  const getPrevInsurance = () => {
    return [
      {
        label: t("mortgageServices.insuranceNo"),
        key: "reservBookNo",
        show: true,
      },
      {
        label: t("mortgageServices.insuranceDate"),
        key: "reservBookDate",
        show: true,
        body: (rowData) => {
          return rowData.reservBookDate
            ? moment(rowData.reservBookDate).format("YYYY-MM-DD")
            : "";
        },
      },
      {
        label: t("mortgageServices.mortgageClass"),
        key: "rankReserv",
        show: true,
        body: (rowData) => {
          return configFun().mortgageClasses[+rowData.rankReserv]?.label;
        },
      },
    ];
  };
  const getFields = () => {
    return [
      {
        label: t("realtySelling.nationalId"),
        key: "partyId",
        body: (rowData) => {
          return rowData.partyId || rowData.nationalId;
        },
        show: true,
      },
      {
        label: sellingWithMortgage
          ? t("realtySelling.buyerName")
          : t("realtySelling.ownerName"),
        key: "partyName",
        body: (rowData) => {
          return rowData.partyName || rowData.buyerArabicName;
        },
        show: true,
      },
      {
        label: t("mortgageServices.apartmentShares"),
        key: "ownShares",
        body: (rowData) => {
          return isFlat(rowData.landFlag)
            ? `${rowData.ownShares} / ${rowData.shareNo}`
            : "-";
        },
        show: hasFlat() && !sellingWithMortgage,
        style: { whiteSpace: "nowrap" },
      },
      {
        label: t("mortgageServices.landShares"),
        key: "landShares",
        body: (rowData) => {
          return isLand(rowData.landFlag)
            ? `${rowData.ownShares} / ${rowData.shareNo}`
            : "-";
        },
        show: hasLand() && !sellingWithMortgage,
        style: { whiteSpace: "nowrap" },
      },
      {
        label: t("realtySelling.personStatus"),
        key: "personStatus",
        body: (rowData) => {
          if (sellingWithMortgage) {
            return getPersonStatus(0);
          }
          return rowData.personStatus;
        },
        show: true,
      },
      {
        label: t("mortgageServices.mortgageStoppers"),
        key: "internalActions",
        body: (rowData) => {
          return rowData["externalReserve"] &&
            rowData["externalReserve"].length ? (
            <span
              onClick={() => handleExternal(rowData)}
              className="text-primary cursor-pointer text-decoration-underline"
            >
              {`${t("realtySelling.thereIs")} ${
                rowData["externalReserve"].length
              }`}
            </span>
          ) : (
            t("realtySelling.thereIsNot")
          );
        },
        show: true,
      },
      {
        label: t("mortgageServices.pastMortgage"),
        key: "externalActions",
        body: (rowData) => {
          return rowData["internalReserve"] &&
            rowData["internalReserve"].length ? (
            <span
              onClick={() => handleInternal(rowData)}
              className="text-primary cursor-pointer text-decoration-underline"
            >
              {`${t("realtySelling.thereIs")} ${
                rowData["internalReserve"].length
              }`}
            </span>
          ) : (
            t("realtySelling.thereIsNot")
          );
        },
        show: true,
      },
    ];
  };

  const hasFlat = () => {
    let flat = false;
    selectedShares.map((item) => {
      if (item.landFlag === "FLAT") {
        flat = true;
      }
    });
    return flat;
  };

  const hasLand = () => {
    let land = false;
    selectedShares.map((item) => {
      if (isLand(item.landFlag)) {
        land = true;
      }
    });
    return land;
  };

  useEffect(() => {
    if (!demo) {
      if (formik.isValid) {
        props.onDisableNext(false);
      } else {
        props.onDisableNext(true);
      }
    }
  }, [formik.isValid]);

  useEffect(() => {
    getLandInsurance(sellingFormDetails.propertyData.reG_NO).then((res) => {
      // setPrevInsuranceData(res.data)
      formik.setFieldValue("prevInsuranceData", res.data);
    });
  }, [sellingFormDetails.propertyData.reG_NO]);

  const handleBlur = (e) => {
    formik.handleBlur(e);
    formik.submitForm();
  };

  const handleCheckbox = async (e, name) => {
    await formik.setFieldValue(name, e.target.value);
    formik.submitForm();
  };

  const handleAddTenant = () => {
    // const length = formik.values.tenants.length;

    const data = JSON.parse(JSON.stringify(formik.values.tenants));
    data.push("");
    formik.setFieldValue("tenants", data);
  };

  const handleRemoveTenant = () => {
    const data = JSON.parse(JSON.stringify(formik.values.tenants));
    data.pop();

    formik.setFieldValue("tenants", data);
  };

  return (
    <RealtySellingWrapper>
      <React.Fragment>
        <PageLayoutWithSidebar className="mt-4">
          <p className="fm-kufi-bold text-sm">
            {t("mortgageServices.selectedShares")}{" "}
            {/* <span className="text-danger">*</span> */}
          </p>

          <DataTable
            className="realty-table fm-kufi-regular"
            paginator
            rows={5}
            tableClassName="w-100"
            value={sellingWithMortgage ? buyersDetails : selectedShares}
            responsiveLayout="scroll"
            emptyMessage={t("common.noResultsFound")}
          >
            {getFields().map(
              (item) =>
                item.show && (
                  <Column
                    key={item.key}
                    field={item.key}
                    header={item.label}
                    body={item.body ? item.body : null}
                    style={item.style || {}}
                  />
                )
            )}
          </DataTable>
        </PageLayoutWithSidebar>
        {mortgage && (
          <PageLayoutWithSidebar className="mt-4">
            <p className="fm-kufi-bold text-sm">
              {t("mortgageServices.prevInsuranceInfo")}{" "}
            </p>

            <DataTable
              className="realty-table fm-kufi-regular"
              paginator
              rows={5}
              tableClassName="w-100"
              value={formik.values.prevInsuranceData}
              responsiveLayout="scroll"
              emptyMessage={t("common.noResultsFound")}
            >
              {getPrevInsurance().map(
                (item) =>
                  item.show && (
                    <Column
                      key={item.key}
                      field={item.key}
                      header={item.label}
                      body={item.body ? item.body : null}
                      style={item.style || {}}
                    />
                  )
              )}
            </DataTable>
          </PageLayoutWithSidebar>
        )}
        <PageLayoutWithSidebar className="mt-4">
          <p className="fm-kufi-bold text-sm">
            {t("mortgageServices.mortgageInfo")}{" "}
            {/* <span className="text-danger">*</span> */}
          </p>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <label className="block text-sm fm-kufi-regular text-form-label">
                {t("mortgageServices.mortgageClass")}{" "}
                <span className="text-danger">*</span>
              </label>
              <Dropdown
                value={formik.values.mortgageClass}
                onChange={formik.handleChange}
                className={classNames({
                  "col-12 py-1": true,
                })}
                options={configFun().mortgageClasses}
                optionLabel="label"
                optionValue="value"
                name="mortgageClass"
                onBlur={handleBlur}
                disabled={demo}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <label className="block text-sm fm-kufi-regular text-form-label">
                {t("mortgageServices.mortgageAmount")}
                <span className="text-danger">*</span>
              </label>
              <div className="d-flex flex-column">
                <div className="p-inputgroup dinar-group flex-row-reverse">
                  <InputText
                    className="py-1 w-25 bg-disabled-color dinar"
                    disabled
                    name="unit"
                    value={t("realtySelling.dinar")}
                  />
                  <InputText
                    name="mortgageAmount"
                    keyfilter="pnum"
                    value={formik.values.mortgageAmount}
                    onChange={formik.handleChange}
                    className="w-100 py-1 dinar-value"
                    maxLength={10}
                    onBlur={handleBlur}
                    disabled={demo}
                  />
                </div>
              </div>
            </div>
          </div>
          {mortgage || sellingWithMortgage ? (
            <>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12 mt-3">
                  <label className="block text-sm fm-kufi-regular text-form-label">
                    {t("mortgageServices.mortgagePeriod")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <Dropdown
                    value={formik.values.mortgagePeriod}
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleBlur(e);
                    }}
                    className={classNames({
                      "col-12 py-1": true,
                    })}
                    options={[
                      {
                        label: t("mortgageServices.order"),
                        value: "order",
                      },
                      {
                        label: t("mortgageServices.period"),
                        value: "period",
                      },
                    ]}
                    optionLabel="label"
                    optionValue="value"
                    name="mortgagePeriod"
                    onBlur={handleBlur}
                    disabled={demo}
                  />
                </div>
              </div>
              {formik.values.mortgagePeriod === "period" && (
                <div className="row">
                  <InputsComponent
                    title={t("mortgageServices.dueDate")}
                    required
                    formik={formik}
                    name="dueDate"
                    type="date"
                    value={
                      typeof formik.values.dueDate === "string" &&
                      formik.values.dueDate
                        ? new Date(formik.values.dueDate)
                        : formik.values.dueDate
                    }
                    disabled={demo}
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleBlur(e);
                    }}
                    // max={new Date()}
                    onBlur={handleBlur}
                  />
                </div>
              )}
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12 my-3">
                  <label className="block text-sm fm-kufi-regular text-form-label">
                    {t("mortgageServices.interest")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <Dropdown
                    value={formik.values.interest}
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleBlur(e);
                    }}
                    className={classNames({
                      "col-12 py-1": true,
                    })}
                    options={[
                      {
                        label: t("mortgageServices.withInterest"),
                        value: "withInterest",
                      },
                      {
                        label: t("mortgageServices.noInterest"),
                        value: "noInterest",
                      },
                    ]}
                    optionLabel="label"
                    optionValue="value"
                    name="interest"
                    onBlur={handleBlur}
                    disabled={demo}
                  />
                </div>
              </div>
              {formik.values.interest === "withInterest" && (
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                    <label className="block text-sm fm-kufi-regular text-form-label">
                      {t("mortgageServices.interest")}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex flex-column">
                      <div className="p-inputgroup dinar-group flex-row-reverse">
                        <InputText
                          className="py-1 w-25 bg-disabled-color dinar"
                          disabled
                          name="unit"
                          value={"%"}
                        />
                        <InputText
                          name="interestValue"
                          keyfilter="pnum"
                          value={formik.values.interestValue}
                          onChange={formik.handleChange}
                          className="w-100 py-1 dinar-value"
                          maxLength={10}
                          onBlur={handleBlur}
                          disabled={demo}
                        />
                      </div>
                      {getFormErrorMessage(formik, "interestValue")}
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                  <label className="block text-sm fm-kufi-regular text-form-label">
                    {t("mortgageServices.commission")}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex flex-column">
                    <div className="p-inputgroup dinar-group flex-row-reverse">
                      <InputText
                        className="py-1 w-25 bg-disabled-color dinar"
                        disabled
                        name="unit"
                        value={"%"}
                      />
                      <InputText
                        name="commission"
                        keyfilter="pnum"
                        value={formik.values.commission}
                        onChange={formik.handleChange}
                        className="w-100 py-1 dinar-value"
                        maxLength={10}
                        onBlur={handleBlur}
                        disabled={demo}
                      />
                    </div>
                    {getFormErrorMessage(formik, "commission")}
                  </div>
                </div>
              </div>
            </>
          ) : null}
          <div className="row">
            <div className="row mt-2">
              <div className="d-flex flex-column col-lg-4 col-md-6 col-sm-12">
                <label className="block text-sm fm-kufi-regular text-form-label">
                  {t("mortgageServices.mortgageTerms")}
                </label>
                <InputTextarea
                  onBlur={handleBlur}
                  value={formik.values.mortgageTerms}
                  name="mortgageTerms"
                  onChange={formik.handleChange}
                  disabled={demo}
                />
              </div>
            </div>
          </div>
        </PageLayoutWithSidebar>

        {foreclosureSale ? null : (
          // <PageLayoutWithSidebar className="mt-4">
          //   <div className="">
          //     <p className="fm-kufi-bold text-sm">
          //       {t("mortgageServices.additionalInfo")}{" "}
          //       {/* <span className="text-danger">*</span> */}
          //     </p>
          //     <div className="d-flex flex-md-row flex-column gap-3">
          //       <div className="">
          //         <label className="block text-sm fm-kufi-regular text-form-label mb-2">
          //           {t(
          //             "OwnershipTransfer.foreclosureSale.isThereAmendmentToDebtor"
          //           )}
          //         </label>
          //         <div className="d-flex flex-row flex-wrap gap-2">
          //           <div>
          //             <RadioButton
          //               value={true}
          //               checked={formik.values.isThereAmendmentToDebtor}
          //               name="isThereAmendmentToDebtor"
          //               disabled={demo}
          //               onChange={(e) =>
          //                 handleCheckbox(e, "isThereAmendmentToDebtor")
          //               }
          //             />
          //             <label className="fm-kufi-regular text-sm">
          //               {t(
          //                 "OwnershipTransfer.foreclosureSale.change-of-debtor/collection-of-fees"
          //               )}
          //             </label>
          //           </div>
          //           <div>
          //             <RadioButton
          //               value={false}
          //               checked={!formik.values.isThereAmendmentToDebtor}
          //               disabled={demo}
          //               name="isThereAmendmentToDebtor"
          //               onChange={(e) =>
          //                 handleCheckbox(e, "isThereAmendmentToDebtor")
          //               }
          //             />
          //             <label className="fm-kufi-regular text-sm">
          //               {t(
          //                 "OwnershipTransfer.foreclosureSale.keep-the-same-debtor-and-change-the-agent"
          //               )}
          //             </label>
          //           </div>
          //         </div>
          //       </div>
          //     </div>
          //   </div>
          // </PageLayoutWithSidebar>
          <PageLayoutWithSidebar className="mt-4">
            <div className="">
              <p className="fm-kufi-bold text-sm">
                {t("mortgageServices.additionalInfo")}{" "}
                {/* <span className="text-danger">*</span> */}
              </p>
              <div className="d-flex flex-md-row flex-column gap-3">
                <div className="col-6 col-md-4">
                  <label className="block text-sm fm-kufi-regular text-form-label">
                    {t("mortgageServices.isTransferableMortgage")}
                  </label>
                  <div className="d-flex flex-row gap-2">
                    <div>
                      <RadioButton
                        value={true}
                        checked={formik.values.isTransferableMortgage}
                        name="isTransferableMortgage"
                        disabled={demo}
                        onChange={(e) =>
                          handleCheckbox(e, "isTransferableMortgage")
                        }
                      />
                      <label className="fm-kufi-regular text-sm">
                        {t("common.yes")}
                      </label>
                    </div>
                    <div>
                      <RadioButton
                        value={false}
                        checked={!formik.values.isTransferableMortgage}
                        disabled={demo}
                        name="isTransferableMortgage"
                        onChange={(e) =>
                          handleCheckbox(e, "isTransferableMortgage")
                        }
                      />
                      <label className="fm-kufi-regular text-sm">
                        {t("common.no")}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-6 col-md-4">
                  <label className="block text-sm fm-kufi-regular text-form-label">
                    {t("mortgageServices.isRented")}
                  </label>
                  <div className="d-flex flex-row gap-2">
                    <div>
                      <RadioButton
                        value={true}
                        checked={formik.values.isRented}
                        name="isRented"
                        onChange={(e) => handleCheckbox(e, "isRented")}
                        disabled={demo}
                      />
                      <label className="fm-kufi-regular text-sm">
                        {t("common.yes")}
                      </label>
                    </div>
                    <div>
                      <RadioButton
                        value={false}
                        checked={!formik.values.isRented}
                        name="isRented"
                        onChange={(e) => handleCheckbox(e, "isRented")}
                        disabled={demo}
                      />
                      <label className="fm-kufi-regular text-sm">
                        {t("common.no")}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <>
                <div className="d-flex gap-2 mt-4 align-items-center">
                  <p className=" fm-kufi-bold d-inline m-0 p-0">
                    {t("mortgageServices.tenants")}
                  </p>
                </div>
                {formik.values.tenants.map((item, index) => (
                  <div key={`${item.id}${index}`}>
                    <InputsRow>
                      <InputsComponent
                        title={
                          t("mortgageServices.tenantName") + ` ${index + 1}`
                        }
                        // required
                        double
                        formik={formik}
                        name={index === 0 ? "tenant" : `tenant${index}`}
                        value={formik.values.tenants[index]}
                        onChange={(e) => {
                          const data = JSON.parse(
                            JSON.stringify(formik.values.tenants)
                          );
                          data[index] = e.target.value;
                          formik.setFieldValue("tenants", data);
                        }}
                        disabled={demo}
                        onBlur={handleBlur}
                      />
                    </InputsRow>
                  </div>
                ))}
                <div className="d-flex gap-4">
                  <Button
                    className="add-buyer fm-kufi-regular text-sm offset-3"
                    label={t("mortgageServices.addNewTenant")}
                    icon="pi pi-plus"
                    iconPos="left"
                    onClick={handleAddTenant}
                  />

                  <Button
                    className="add-buyer fm-kufi-regular text-sm offset-3 text-danger"
                    label={t("mortgageServices.removeTenant")}
                    onClick={() => handleRemoveTenant()}
                  />
                </div>
              </>
            </div>
          </PageLayoutWithSidebar>
        )}
      </React.Fragment>

      <Modal
        className="insideModal"
        closable={false}
        okText={t("common.close")}
        width="800px"
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{
          className:
            "ant-btn ant-btn-default action-btn col-md-2 col-xs-4 btn-bg-main fm-kufi-regular  text-sm submit-btn",
        }}
        visible={internalModal}
        onOk={() => setInternalModal(false)}
      >
        <DataTable
          className="mt-4 text-xs fm-kufi-regular"
          size="small"
          value={internalReserve}
        >
          {reserveColumns.map((column) => (
            <Column
              className="text-center"
              field={column.key}
              header={column.label}
              key={column.key}
              body={column.body ? column.body : null}
            />
          ))}
        </DataTable>
      </Modal>

      <Modal
        className="insideModal"
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
        okText={t("common.close")}
        width="800px"
        okButtonProps={{
          className:
            "ant-btn ant-btn-default action-btn col-md-2 col-xs-4 btn-bg-main fm-kufi-regular  text-sm submit-btn",
        }}
        visible={externalModal}
        onOk={() => setExternalModal(false)}
      >
        <DataTable
          className="mt-4 text-xs fm-kufi-regular"
          size="small"
          value={externalReserve}
        >
          {reserveColumnsExternal.map((column) => (
            <Column
              className="text-center"
              field={column.key}
              header={column.label}
              key={column.key}
              body={column.body ? column.body : null}
            />
          ))}
        </DataTable>
      </Modal>
    </RealtySellingWrapper>
  );
};

export default MortgageInfo;
